var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#123766"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7425 11.5V10C12.7425 9.44772 13.1902 9 13.7425 9H23.3138C23.8661 9 24.3138 9.44772 24.3138 10V11.5M12.7425 11.5H10.3C9.74776 11.5 9.30005 11.9477 9.30005 12.5V13.5C9.31544 15.4232 10.2135 16.3477 13 17.7904M12.7425 11.5L12.7425 16.3971C12.7425 16.8697 12.8334 17.3389 13 17.7904M24.3138 11.5H26.7C27.2523 11.5 27.7 11.9477 27.7 12.5V13.5C27.6576 15.5299 26.7243 16.4623 23.9724 17.7904M24.3138 11.5V16.3971C24.3138 16.8344 24.1921 17.3106 23.9724 17.7904M18.4988 21.5V24M18.4988 21.5C16.0426 21.5 13.7511 19.8254 13 17.7904M18.4988 21.5C20.8759 21.5 23.1354 19.618 23.9724 17.7904M18.4988 24C20.9305 24.8907 22.4937 25.4949 23.1487 26.1673C23.5152 26.5435 23.0915 27 22.5663 27H14.3812C13.8771 27 13.4764 26.5734 13.8373 26.2214C14.5487 25.5277 16.2995 24.9037 18.4988 24Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4995 11.5V16C15.6022 17.1891 16.096 17.7277 16.9995 18",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinningIcon);
export default __webpack_public_path__ + "static/media/winningIcon.8e050c0ef700026c3fac31a21ee790b6.svg";
export { ForwardRef as ReactComponent };